// Maybe turn this into a class?
import cookies from 'js-cookie';
import to from 'await-to-js';
import unfetch from 'unfetch';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
//import cookies from 'js-cookie';
import { generateUniqueKey } from 'lib/helpers';
import { getShortID } from 'lib/salesforce';

/*
 * Cart expiry.
 */
const cartExpiry = 100;

/**
 * For now we are using old checkout.
 */
export const proceedToCheckout = () => {

  if( typeof window === 'undefined' ) {
    return;
  }

  const cart = getCart();
  cookies.set( 'cart', cart);

  trackCustomEvent( {
    category: 'Ecommerce',
    action: 'Proceeded to Checkout',
    label: window.location.pathname,
  } );

  window.location.href = 'https://www.dartdrones.com/cart';

}

/**
 * Get cart.
 *
 * @return {object}
 */
export const getCart = () => {

  if( typeof window === 'undefined' ){
    return {};
  }
  //const cartCache = window.localStorage.getItem( 'cart' );
  const cartCache = cookies.get( 'cart' );
  const cart = !! cartCache ? JSON.parse( cartCache ) : {};

  return cart;

}

/**
 * Adjust quantity.
 *
 * @param {int} productID
 * @param {int} quantity
 */
export const adjustQuantity = ( productID, quantity ) => {

  if( typeof window === 'undefined' ) {
    return;
  }

  const cart = getCart();

  if( ! cart || ! cart.products ) {
    return console.error( 'No cart found' );
  }

  if( ! cart.products[productID] ) {
    return console.warn( `Product ${productID} not in cart!` );
  }

  cart.products[productID].quantity = quantity;
  cookies.set( 'cart', JSON.stringify( cart ) );
//  window.localStorage.cart = JSON.stringify( cart );

}

/**
 * Add to cart.
 *
 * @param {object} productData   {string}  productID   Salesforce ID.
 *                                {object}  courseInfo  Sanity info...
 * @return {bool}
 */
export const addToCart = ( { courseInfo, productID, productName, price, quantity, sku, proceedToCheckout: goToCheckout } ) => {

  if( typeof window === 'undefined' ) {
    return
  }

  const id = getShortID( productID );
  const cart = getCart();
  if( ! cart.id ) {
    cart.id = generateUniqueKey( 10 );
  }
  if( ! cart.products ) {
    cart.products = {};
  }
  let totalQuantity = quantity || 1;

  // Check to see if product already exists in cart.
  if( !! cart.products[id] ) {
    totalQuantity = totalQuantity + cart.products[id].quantity;
  }

  let instructor = null;
  let filteredCourseInfo = null;
  if( !! courseInfo ) {
    let { instructor, ...filteredCourseInfo } = courseInfo;
  }


  cart.products[id] = {
    courseInfo: filteredCourseInfo || null,
    productID: id,
    productName,
    price: typeof price === 'string' ? parseFloat( price ) : price,
    quantity: totalQuantity,
    sku,
  }

  //window.localStorage.cart = JSON.stringify( cart )
  cookies.set( 'cart', JSON.stringify( cart ) );

  // Add to salesforce.
  // unfetch( `${process.env.FUNCTIONS_URL}/sf-update-cart`, {
  //   method: 'POST',
  //   body: JSON.stringify( {
  //     cart
  //   } )
  // } );
  trackCustomEvent( {
    category: 'Ecommerce',
    action: 'Added to Cart',
    label: !! courseInfo && courseInfo.parentName ? courseInfo.parentName : productName,
    value: typeof price === 'string' ? parseFloat( price ) : price,
  } );

  // unfetch( `${window.FUNCTIONS_URL}/sf-update-cart`, {
  //   method: 'POST',
  //   body: JSON.stringify( {
  //     cart
  //   } )
  // } );

  if( goToCheckout ) {
    proceedToCheckout();
  }


}

/**
 * Remove from cart.
 *
 * @param {int} productID
 */
export const removeFromCart = productID => {

  if( typeof window === 'undefined' ) {
    return;
  }

  const cart = getCart();

  if( ! cart.products ) {
    return console.error( 'Cart has no products' );
  }

  delete cart.products[productID];

  //window.localStorage.cart = JSON.stringify( cart );
  cookies.set( 'cart', JSON.stringify( cart ) );

}